export default {
  'Lendo os livros': [
    `{{ No momento nenhum }}`
  ],
  'Estudando': [
    `JavaScript`,
    `ReactNative`,
    `Vuejs`,
    `Laravel`
  ],
  'Adquirindo/Removendo hábito(s)': [
    `Tentando deixar de comer pão de queijo todo dia`
  ],
  'Projeto(s) atual(is)': [
    `<a href="http://revista.transformando.com.vc" target="_blank">Revista Vida Cooperativa</a>`,
    `<a href="http://captamos.nossacausa.com" target="_blank">Captamos</a>`,
    `This project`
  ],
  'Metas e objetivos': [
    `Escrever mais em meu blog`,
    `<strike>Ir para academia 2x na semana</strike> ~falhando miseravelmente~`
  ]
}
